import React from "react";
import { CpToggle } from "@components";
import {
  useController,
  Control,
  RegisterOptions,
  UseControllerProps,
  FieldValues,
  FieldPath,
} from "react-hook-form";

type CpToggleFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  React.ComponentPropsWithoutRef<typeof CpToggle>,
  "checked" | "onChange" | "onBlur"
> & {
  control: Control<TFieldValues>;
  controllerOptions?: Omit<
    UseControllerProps<TFieldValues>,
    "name" | "control" | "rules"
  >;
  fieldName: FieldPath<TFieldValues>;
  rules?: RegisterOptions<TFieldValues>;
};

export function CpToggleField<TFieldValues extends FieldValues = FieldValues>(
  props: CpToggleFieldProps<TFieldValues>,
) {
  const { fieldName, control, controllerOptions, rules, ...cpToggleProps } =
    props;
  const {
    field: { value, onBlur, onChange },
  } = useController({ name: fieldName, control, rules, ...controllerOptions });

  return (
    <CpToggle
      {...cpToggleProps}
      checked={value}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
}
